import { type RouteObject } from 'react-router-dom';

import { requirePermissions } from '@/app/requirePermissions';
import { PagePermissions } from '@/models/pagePermissions';

export const giftRoute: RouteObject = {
  path: 'gifts',
  loader: requirePermissions({ oneOf: PagePermissions.gifts }),
  children: [
    {
      path: '',
      lazy: () => import('./gifts'),
    },
  ],
};
